import { render } from "./VabeneEditCustomer.vue?vue&type=template&id=784119f5&ts=true"
import script from "./VabeneEditCustomer.vue?vue&type=script&lang=ts"
export * from "./VabeneEditCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__